import React from 'react'
import classes from "./Banner.module.css"
const Banner = () => {
  return (
    <div>


<div className={classes.banner}>

<h2  className={classes.ih4}>Contact Us</h2>
<h4 className={classes.ih41}><a href="https://rcgcounselling.com" className={classes.ih41}>Home </a>| <a href="https://rcgcounselling.com/Contact" className={classes.ih41}>Contact Us</a></h4> 
{/* <h2  className={classes.ih41}>Please Feel Free To Contact Us</h2> */}

</div>

    </div>
  )
}

export default Banner